export default "__VITE_ASSET__a440bc0e__"